export default __webpack_public_path__ + "static/media/blurredDashboard.63cca49c.avif";